export const ALL_LISTING_ANIMAL_INQUIRY = 'ALL_LISTING_ANIMAL_INQUIRY'
export const ALL_LISTING_JUDGE_INQUIRY = 'ALL_LISTING_JUDGE_INQUIRY'
export const ALL_LISTING_EQUIPMENT_INQUIRY = 'ALL_LISTING_EQUIPMENT_INQUIRY'
export const ALL_LISTING_INQUIRY_SUCCESS = 'ALL_LISTING_INQUIRY_SUCCESS'
export const SET_LOADING = 'SET_LOADING'
